import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface WindowPositionCommand {
  deviceViewEntityId: DeviceViewEntityId;
  x: number;
  y: number;
}

export const updateWindowPosition: DeviceViewCommandFactory<
  WindowPositionCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    const foundWindow = draft.deviceViewWindows.find(
      (win) => win.id === command.deviceViewEntityId,
    );
    if (foundWindow !== undefined) {
      foundWindow.x = command.x;
      foundWindow.y = command.y;
    }
  });
};
